// Only the scoped backend evidence contract may populate these cards. Never
// derive them from TrueView views, generic VCR or the legacy completion count.
export function readYoutubeQuartileRates(metrics) {
  return Object.fromEntries([25, 50, 75, 100].map(milestone => {
    const evidence = metrics?.youtubeQuartileRates?.[milestone];
    const value = evidence?.value;
    const ratio = typeof value === 'number' && Number.isFinite(value)
      ? evidence.unit === 'ratio' ? value : evidence.unit === 'percent' ? value / 100 : null
      : null;
    return [`youtubePlayed${milestone}Rate`, ratio !== null && ratio >= 0 && ratio <= 1 ? ratio : null];
  }));
}
